import Vue from "vue";
import App from "./app.vue";

import VueScreenSize from "vue-screen-size";
Vue.use(VueScreenSize);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
